import { findRowInList } from "@/api/fileRecordCache";
import type { FileRecord } from "@cohesive/api-client";

/** Canvas node entities often carry a stub; prefer the cached API record when available. */
export function resolveFileRecordFromList(
  record: FileRecord | null | undefined,
  allRecords: readonly FileRecord[],
): FileRecord | null {
  if (!record?.id) {
    return null;
  }
  return findRowInList(allRecords, record.id) ?? record;
}
